import styled from 'styled-components';

const FormTitleNumber = styled<{ isActive: boolean }, 'span'>('span')`
  width: 32px;
  height: 32px;
  text-align: center;
  border-radius: 50%;
  margin-left: -52px;
  margin-right: 20px;
  display: inline-block;
  border: 1px solid ${props => (props.isActive ? '#00144D' : '#BDBDBD')};
  color: ${props => (props.isActive ? '#00144D' : '#BDBDBD')};
`;

export default FormTitleNumber;



// WEBPACK FOOTER //
// ./src/components/FormComponents/FormTitleNumber.tsx